import React, { useEffect } from "react";
import PageChrome, { BuyButton, PriceTag, INK, LIME, BLUE, BG_ALT } from "./components/PageChrome";
import { PRODUCTS } from "./products";

const P = PRODUCTS.toolkit;

const FOR_WHOM = ["CFOs y tesoreros", "Fundadores de SOFOM / fintech", "Analistas de crédito", "Founders levantando su primera línea"];
const FAQ = [
  ["¿Es para mí si nunca he levantado deuda?", "Sí. El Toolkit está pensado justo para tu primer fondeo: te da los formatos que un fondo espera ver, sin que tengas que inventarlos."],
  ["¿En qué formato viene?", "Excel + PDF + un video walkthrough de 40 min. Acceso inmediato después de pagar."],
  ["¿Sirve para PyME y para lender?", "Sí — incluye el modelo de cartera para plataformas de crédito y el de capital de trabajo para PyME."],
  ["¿Tiene garantía?", "7 días, sin preguntas. Si no te sirve, te devuelvo tu dinero."],
];

export default function Toolkit() {
  useEffect(() => { document.title = "The Debt Toolkit · The Debt Guy"; }, []);
  return (
    <PageChrome active="/toolkit" testid="toolkit-page">
      {/* Hero */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "80px 40px 40px" }} data-testid="toolkit-hero">
        <div className="cg-mono cg-eyebrow">— El producto de entrada</div>
        <h1 className="cg-h1" style={{ marginTop: 18, maxWidth: 900 }} data-testid="toolkit-hero-title">
          Los modelos y checklists que uso para <span style={{ color: BLUE }}>preparar un fondeo.</span>
        </h1>
        <p style={{ marginTop: 22, fontSize: 19, lineHeight: 1.55, opacity: 0.78, maxWidth: 640 }}>
          {P.blurb} Todo lo que necesitas para llegar a la mesa con un fondo sin verte amateur.
        </p>
        <div style={{ marginTop: 30 }}><PriceTag product={P} /></div>
        <div style={{ marginTop: 24, display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
          <BuyButton lookupKey={P.key} testid="toolkit-buy" style={{ padding: "18px 34px", fontSize: 13 }}>Comprar el Toolkit →</BuyButton>
          <span className="cg-mono" style={{ opacity: 0.55, fontSize: 10 }}>Pago único · acceso inmediato · garantía 7 días</span>
        </div>
      </section>

      {/* What's included */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "50px 40px" }} data-testid="toolkit-includes">
        <div className="cg-mono cg-eyebrow">— Qué incluye</div>
        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 16 }}>
          {P.features.map((f, i) => (
            <div key={i} className="cg-card" style={{ padding: 24, minHeight: 130 }}>
              <span className="cg-mono" style={{ color: BLUE, fontSize: 11 }}>{String(i + 1).padStart(2, "0")}</span>
              <div style={{ marginTop: 12, fontSize: 16, fontWeight: 700, lineHeight: 1.35 }}>{f}</div>
            </div>
          ))}
        </div>
      </section>

      {/* For whom */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "30px 40px 50px" }}>
        <div className="cg-mono cg-eyebrow">— Para quién</div>
        <div style={{ marginTop: 20, display: "flex", gap: 12, flexWrap: "wrap" }}>
          {FOR_WHOM.map((w) => (
            <span key={w} style={{ border: `2px solid ${INK}`, borderRadius: 999, padding: "10px 18px", fontSize: 13, fontWeight: 700, background: BG_ALT }}>{w}</span>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "30px 40px 60px" }} data-testid="toolkit-faq">
        <div className="cg-mono cg-eyebrow">— Preguntas</div>
        <div style={{ marginTop: 22, display: "flex", flexDirection: "column", gap: 14 }}>
          {FAQ.map(([q, a], i) => (
            <div key={i} className="cg-card" style={{ padding: 24 }}>
              <div style={{ fontWeight: 800, fontSize: 16 }}>{q}</div>
              <div style={{ marginTop: 8, opacity: 0.78, lineHeight: 1.55, fontSize: 14.5 }}>{a}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section style={{ maxWidth: 1100, margin: "0 auto 80px", padding: "0 40px" }}>
        <div style={{ background: BLUE, color: "#FFFFFF", border: `2px solid ${INK}`, borderRadius: 20, boxShadow: `6px 6px 0 ${INK}`, padding: "48px 40px", textAlign: "center" }}>
          <h2 className="cg-h2" style={{ color: "#FFFFFF" }}>Llega a la mesa como profesional.</h2>
          <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
            <BuyButton lookupKey={P.key} testid="toolkit-buy-bottom" style={{ padding: "18px 34px", fontSize: 13 }}>Comprar el Toolkit · {P.usd} →</BuyButton>
          </div>
        </div>
      </section>
    </PageChrome>
  );
}
